<script>

import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import Icon from 'fa-svelte';
import { createEventDispatcher } from 'svelte';
import { getFacebookLink,getLinkedinLink,getTwitterLink } from './data.js';
import { getTrad,language } from './js/AppState';
import DataLoading from './js/DataLoading.js';
import SGMSApi from './js/SGMSApi.js';
const dispatch = createEventDispatcher();





export let showLanguages;

let languages = DataLoading.languages

$: sortedLanguages = languages.filter(l => l.id !== $language)
$: la = languages.find(l => l.id === $language)
$: sortedLanguages.unshift(la)


let langOpened = false
function openLang() {
  langOpened = true
}

let socialOpened = false
function toggleSocial() {
  socialOpened = !socialOpened
}

function select(id, e) {
  SGMSApi.sendActionEvent(e, "topbar_change_language." + id)
  language.set(id)
  langOpened = false
}
function handleClick(id, e) {
  SGMSApi.sendActionEvent(e, id)
}
</script>

<div id="topbar">

  <span class="social">
    <a on:click={handleClick.bind(null, "topbar_facebook_link")} href={getFacebookLink($getTrad("facebook_start"))} target="_blank" class="i" ><Icon icon={faFacebookF}></Icon></a>
    <a on:click={handleClick.bind(null, "topbar_twitter_link")} href={getTwitterLink($getTrad("twitter_start"))} target="_blank" class="i" ><Icon icon={faTwitter}></Icon></a>
    <a on:click={handleClick.bind(null, "topbar_linkedin_link")} href={getLinkedinLink($getTrad("linkedin_start"))}  target="_blank" class="i" ><Icon icon={faLinkedinIn}></Icon></a>
  </span>


  {#if showLanguages}
    <div class="languages">
      <span class="sep">|</span>
      {#if langOpened}
        <div class="dropdown">
          {#each sortedLanguages as l}
            <div on:click={select.bind(null, l.id)} class={"lang" + (l.id === $language ? " bold" : "")}>
              {l.short}
            </div>
          {/each}
        </div>
      {:else}
        <div class="lang bold" on:click={openLang} >{$language}</div>
      {/if}
    </div>
  {/if}

</div>


<style>
  #topbar {
    position: absolute;
    top: 0;
    right: 0;
    padding: 20px;
    display: flex;
    align-items: flex-start;
  }

  .i { margin: 0 10px; }

  a { color: #000; }

  .social-mobile { display: none; }

  .languages {
    display: flex;
    width: 40px;
  }

  .lang {
    text-transform: uppercase;
    margin: 2px 4px;
    margin-bottom: 5px;
    cursor: pointer;
    line-height: 1em;
  }

  .lang.bold { font-weight: bold; }

  .sep { line-height: 1em; }

  @media screen and (max-width: 800px) {
    #topbar { display: none; }
  }
</style>
